// extracted by mini-css-extract-plugin
export default {"sidebarContent":"WSTooltip-module_sidebarContent-fsZLT"};